import { useEffect } from 'react';
import { StorageManager, useStorage } from '@funtech-int/web-toolkit';
import { useAuthManager } from '@funtech-int/yango-shared';

import { useLocale } from '@/shared/hooks/useLocale';
import {
    IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_KEY,
    PROFILE_SESSION_TIMESTAMP,
} from '@/shared/lib/profileSession';
import { useSendWebAnalytics } from '@/shared/hooks/useSendWebAnalytics';
import { useBackendClient } from '@/shared/hooks/useBackendClient';

const LOGGED_IN_ANALYTICS_KEY = 'LOGGED_IN_MARKED';

const localStorageItemsToRemove = [
    IS_PROFILE_FAMILY_CHOICE_SUPPRESSED_KEY,
    PROFILE_SESSION_TIMESTAMP,
];

const clearLocalStorage = (storage: StorageManager) => {
    localStorageItemsToRemove.forEach((item: string) => storage.local.remove(item));
};

export const useLoggedInAnalytics = () => {
    const { isAuthorized } = useAuthManager();
    const sendWebAnalytics = useSendWebAnalytics();
    const backendClient = useBackendClient();
    const { lang } = useLocale();
    const storage = useStorage();

    useEffect(() => {
        if (isAuthorized && !storage.local.get(LOGGED_IN_ANALYTICS_KEY)) {
            sendWebAnalytics('AUTH_SUCCESS');
            backendClient?.postLoggedInEvent(
                { type: 'UserLoggedInEvent' },
                {
                    'X-Saft-Client': 'SaftDesktop',
                    'X-Preferred-Language': lang,
                }
            );
            storage.local.set(LOGGED_IN_ANALYTICS_KEY, '1');
        }
        if (!isAuthorized && storage.local.get(LOGGED_IN_ANALYTICS_KEY)) {
            storage.local.remove(LOGGED_IN_ANALYTICS_KEY);
        }

        if (!isAuthorized) {
            clearLocalStorage(storage);
        }
    }, [isAuthorized, backendClient, sendWebAnalytics, storage, lang]);
};
